import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

type ProfileMenuButtonProps = {
    handleClick: () => void;
};

const ProfileMenuButton = ({ handleClick }: ProfileMenuButtonProps) => {
    const { t } = useGranite();

    return (
        <a
            href="#"
            onClick={e => {
                e.preventDefault();
                handleClick();
            }}
        >
            <i className={"las la-angle-left"} />
            {t("profileMenuButton.link.myProfile")}
        </a>
    );
};

export default ProfileMenuButton;
